import {Inject, Injectable, Optional} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {EnvironmentService} from '../../core/enviroment/environment.service';
import {CookieService} from 'ngx-cookie-service';
import { GoogleTagManagerService } from 'src/app/core/analytics/google-tag-manager.service';
import { sanitizeString } from '../functions/StringSanitize';

@Injectable({
  providedIn: 'root'
})
export class LegacyLoginService {

  constructor(
      private readonly environmentService: EnvironmentService,
      private readonly cookieService: CookieService,
      private readonly googleTagManagerService: GoogleTagManagerService,
      @Optional() @Inject(DOCUMENT) private readonly document?: Document) {
  }

  autologin() {
    if ((!this.document || !this.cookieService.get('lps-jwt-token'))) {
      return;
    }
    this.sendLegacyTracking('callback:starting');
    const iframe = this.document.createElement('iframe');

    iframe.setAttribute('src', this.environmentService.getLopesNetProntosAutoLogin());
    iframe.style.display = 'none';

    this.document.defaultView.addEventListener('message', (e: any) => {
      if (e.data.kind !== 'legacyAutoLoginProntos') { return; }

      if (e.data.success === true) {
        this.sendLegacyTracking('callback:success');
      } else {
        this.sendLegacyTracking('callback:error', e.data?.errors);
      }
    });

    this.document.body.appendChild(iframe);
  }

  private sendLegacyTracking(eventAction, eventLabel?) {
    this.googleTagManagerService.pushTag({
      event: 'event',
      eventCategory: 'autologin_prontos',
      eventAction,
      eventLabel: sanitizeString(eventLabel)
    });
  }
}
